import CustomerDelete from './CustomerDelete';

export default CustomerDelete;
